// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingEventLogResponse

import { BookingEventActionType, BookingEventLogStatus } from './enums.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BookingEventLogApiResponse = {
	id: number;
	bookingId: string;
	bookingEventId: string;
	bookingEventName: string;
	actionType: BookingEventActionType;
	executedAt: string;
	status: BookingEventLogStatus;
	customerName: string | null;
	customerEmail: string | null;
	errorMessage: string | null;
};

export type BookingEventLog = {
	id: number;
	bookingId: string;
	bookingEventId: string;
	bookingEventName: string;
	actionType: BookingEventActionType;
	executedAt: DateTime;
	status: BookingEventLogStatus;
	customerName: string | null;
	customerEmail: string | null;
	errorMessage: string | null;
};

export function hydrateBookingEventLog(data: BookingEventLogApiResponse): BookingEventLog {
	return {
		...data,
		executedAt: DateTimefromISO(data.executedAt)!,
	};
}